import React from 'react';

const SummaryPage = React.lazy(() => import('./SummaryPage'));

const SummaryConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SummaryPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default SummaryConfig;
